import { FC } from "react";
import { Box } from "@otrium/core";
import { Theme, useTheme } from "@emotion/react";

interface ProgressBarProps {
  value: number;
  max: number;
}

const ProgressBar: FC<ProgressBarProps> = ({ value, max }) => {
  const theme: Theme = useTheme();
  const percentage = (value / max) * 100;
  return (
    <Box
      sx={{
        height: "8px",
        width: "100%",
        backgroundColor: theme.colors.tone.marble,
        borderRadius: "4px",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          height: "100%",
          width: `${percentage}%`,
          backgroundColor: theme.colors.tone.black,
          borderRadius: "4px",
        }}
      />
    </Box>
  );
};

export default ProgressBar;
